import { GET_PARENTAL_STATUS } from "../../../enums/Request/request.types";

export const getParentalStatusAction = (data) => {
    return {
        type: GET_PARENTAL_STATUS,
        payload: data,
    };
};
